// Sentence search on the dashboard (design B): one tab per section, each
// opening a popup whose sentence has fill-in fields. A sentence is a list of
// plain text pieces and { field } slots, in reading order, worded exactly as
// the client gave it.

export const SEARCH_FIELDS = {
  function: { label: "Function" },
  company_name: { label: "Company Name" },
  company_type: { label: "Company Type" },
  company_size: { label: "Company Size" },
  industry: { label: "Industry" },
  country: { label: "Country" },
  deal_type: { label: "Deal Type" },
  skills: {
    label: "Skill 1, Skill 2, Skill 3, Skill 4",
    summaryLabel: "Skills",
    addLabel: "Add skill",
    multiple: true,
    max: 4,
  },
  tags: {
    label: "Tag 1, Tag 2, Tag 3, Tag 4",
    summaryLabel: "Tags",
    addLabel: "Add tag",
    multiple: true,
    max: 4,
  },
};

export const SEARCH_TABS = [
  {
    key: "executive",
    label: "Executives",
    title: "Executive Search",
    hint: "Find executive profiles by function, company, industry and skills.",
    icon: "fa-user-circle-o",
    color: "#16a34a",
    button: "Build Executive",
    route: "/executive",
    sentence: [
      "A list of", { field: "function" },
      "profiles from", { field: "company_name" },
      ",", { field: "company_type" },
      "and", { field: "company_size" },
      "in the", { field: "industry" },
      "located in", { field: "country" },
      "with", { field: "skills" },
    ],
  },
  {
    key: "company",
    label: "Companies",
    title: "Company Search",
    hint: "Find companies by type, size, industry and tags.",
    icon: "fa-building-o",
    color: "#2563eb",
    button: "Build Company",
    route: "/company",
    sentence: [
      "A list of", { field: "company_type" },
      "and", { field: "company_size" },
      "in the", { field: "industry" },
      "located in", { field: "country" },
      "with", { field: "tags" },
    ],
  },
  {
    key: "news",
    label: "News",
    title: "News Search",
    hint: "Track executive moves across companies and industries.",
    icon: "fa-newspaper-o",
    color: "#d97706",
    button: "Build News",
    route: "/news",
    sentence: [
      "A list of", { field: "function" },
      "executive moves from", { field: "company_name" },
      { field: "company_type" },
      "and", { field: "company_size" },
      "in the", { field: "industry" },
      "located in", { field: "country" },
      "with", { field: "skills" },
    ],
  },
  {
    key: "deals",
    label: "Deals",
    title: "Deals Search",
    hint: "Find deals by type, company, industry and tags.",
    icon: "fa-handshake-o",
    color: "#4f46e5",
    button: "Build Deals",
    route: "/deals-transactions",
    sentence: [
      "A list of", { field: "deal_type" },
      "deals", { field: "company_name" },
      "in the", { field: "industry" },
      "located in", { field: "country" },
      "with", { field: "tags" },
    ],
  },
];

// blank values for every field in a tab's sentence
export function emptyValues(tab) {
  const values = {};
  tab.sentence.forEach((piece) => {
    if (piece.field) {
      values[piece.field] = SEARCH_FIELDS[piece.field].multiple ? [] : null;
    }
  });
  return values;
}
